import apiClient from "@/api/apiClient";

export const getUser = async (id) => {
  const { data } = await apiClient(`/users/get/${id}`);
  return data;
};
